import { createChildListModalContainer } from 'factories/ChildListModal'
import actions from 'actions/cycleCounts/cycleCountDetails'
import Component from 'components/CycleCounts/Items/Select'

export default createChildListModalContainer({ actions })(Component)
